import styled from 'styled-components';

export const InfoMessageText = styled.span`
    font-size: ${({ theme }) => theme.fontSize.xlg};
    color: ${({ theme }) => theme.color.grey[80]};
`;
